import React, { FC } from 'react'
import { Slider, ButtonDep as Button } from '@islandsstofa/react'
import useGetAll from '@root/src/hooks/useGetAll'
import { OpportunityCard } from '../Cards'
import { Link } from 'gatsby'

interface Props {
  title?: string
  link_text?: string
  link_url?: string
  cards?: []
}

const OpportunitySlider: FC<Props> = ({
  title = 'Missing title',
  link_text = 'Missing link text',
  link_url = '/',
  cards
}) => {
  // if cards are provided then use those... otherwise fetch all
  const allCards = useGetAll()
  const opportunities = cards
    ? [
        ...allCards.filter(
          card =>
            card &&
            (card.category == 'Tækifæri' || card.category === 'Viðburður')
        ),
        ...cards
      ]
    : allCards.slice(0, 10)
  if (opportunities.length === 0) return null

  return (
    <section className='page-slice-spacer'>
      <Slider
        cards={opportunities}
        title={title}
        onRenderLink={() => (
          <Link to={link_url}>
            <Button
              className='d-none d-lg-flex align-items-end'
              type='secondary'
              icon='arrowRight'
              label={link_text}
            />
          </Link>
        )}
        flickityOptions={{ wrapAround: true }}
        onRender={card =>
          card.image && (
            <OpportunityCard
              key={card.prismicId}
              card={{ ...card, tags: card.customTags }}
              className='card--slider card--tall'
              wrapperClassName='card--gap card--opportunity'
            />
          )
        }
      />
    </section>
  )
}

export default OpportunitySlider
